import React from 'react';
import './tabs.scss';

class Tabs extends React.Component {
    constructor(props, context) {
        super(props, context);
    }
    static defaultProps = {
        index: 0,
    }
    render() {
        var className = 'pubhub-agenda-tabs';
        var tabIndex = this.props.index;
        var indicatorWidth = 100.0 / this.props.children.length;
        var indicatorLeft = indicatorWidth * tabIndex;
        var indicatorStyle = {
            width: indicatorWidth + '%',
            left: indicatorLeft + '%',
        };
        var self = this;
        var tabs = this.props.children.map(function (child, idx) {
            var tabWrapperClassName = 'tab-wrapper' + (tabIndex == idx ? ' active' : '');
            var content = self.props.displayMember ? child[self.props.displayMember] : child;
            return (
                <div key={idx} className={tabWrapperClassName} onClick={self.onClickTab.bind(self, idx)}>
                    {content}
                </div>
            );
        });

        return (
            <div className={className}>
                <div className='tabs-container'>
                    {tabs}
                </div>
                <div className='tab-indicator-container'>
                    <div className='tab-indicator' style={indicatorStyle} />
                </div>
            </div>
        );
    }
    onClickTab(idx) {
        var e = { target: { value: idx, name: this.props.name, data: idx } };
        this.props.onChange && this.props.onChange(e);
    }
}

export default Tabs;